import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';
import {keys, redirect} from '../shared/constants';
import {isEmpty, routePath} from 'sdv-common';
import {CookieService} from 'ngx-cookie-service';
import {AttendeeService} from '../service/attendee.service';

@Component({
  selector: 'attendee',
  templateUrl: './attendee.component.html',
  styleUrls: ['./attendee.component.scss']
})
export class AttendeeComponent implements OnInit {

  limit = 10;
  offset = 0;

  error = '';
  loading = false;

  constructor(public apiService: ApiService,
              public attendeeService: AttendeeService,
              public cookieService: CookieService) {
    const projectId = this.cookieService.get(keys.project);
    if (this.apiService.isAnonymous()) {
      redirect(routePath.login);
    } else if (isEmpty(projectId)) {
      redirect('/projects');
    } else {
      this.apiService.setParams({
        $project: projectId
      });
    }
  }

  ngOnInit() {
  }
}
